import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DialogService } from "primeng/api";
import { RespostaPaginada } from "./../../../shared/model/sgsia/paginacao-sgsia";
import { RevisaoSeloSgsia } from "./../../../shared/model/sgsia/revisao-selo-sgsia";
import { SegurancaService } from "./../../../shared/service/seguranca.service";

@Component({
    selector: "app-aviso-revisao-selo",
    templateUrl: "./aviso-revisao-selo.component.html",
    styleUrls: ["./aviso-revisao-selo.component.scss"],
})
export class AvisoRevisaoSeloComponent implements OnInit {
    private podeAnalisar: boolean;

    @Input()
    paginacaoRevisoes: RespostaPaginada<RevisaoSeloSgsia>;
    @Input()
    loadLazy: (event: any) => void;

    constructor(
        private segurancaService: SegurancaService,
        private router: Router,
        private dialogService: DialogService
    ) {}

    ngOnInit() {
        this.podeAnalisar =
            this.segurancaService.isAnalistaFiscal() ||
            this.segurancaService.isGestor();
    }

    podeAnalisarRevisao(item: RevisaoSeloSgsia) {
        if(this.podeAnalisar && this.segurancaService.isGestor()){
            return item.situacaoRevisao === RevisaoSeloSgsia.SITUACAO_REVISAO_REVISADA;
        }

        return this.podeAnalisar;
    }

    visualizar(item: RevisaoSeloSgsia) {
        this.dialogService.dialogComponentRef.destroy();
        this.router.navigate([
            "/operacao/sgsia/revisao/visualizar",
            item.idSolicitacao,
        ]);
    }

    revisarSelo(item: RevisaoSeloSgsia) {
        this.dialogService.dialogComponentRef.destroy();
        if (this.segurancaService.isAnalistaFiscal()) {
            this.router.navigate([
                "/operacao/sgsia/revisao/analisar",
                item.idSolicitacao,
            ]);
            return;
        }
        this.router.navigate([
            "/operacao/sgsia/revisao/aprovar-ativacao",
            item.idSolicitacao,
        ]);
    }
}
